import { Stack } from "@mui/material";
import { type FC, Fragment } from "react";
import type { ClientIdentificationDocumentTypeEnum } from "web_myplann/Infrastructure/Api/Api";
import { useResource } from "web_myplann/Infrastructure/Translations/Resources";
import { PaperworkTypeRow } from "web_myplann/Profile/Components/Paperwork/PaperworkTypeRow";
import { ProfileSection } from "web_myplann/Profile/Components/ProfileSection";
import {
	PAPERWORK_DOC_CATEGORIES,
	type PaperworkDocType,
} from "web_myplann/Profile/Constants/paperworkDocTypes";
import { getDocumentIcon } from "web_myplann/Profile/Helpers/paperworkDocument";

type Props = {
	selectedTypeId?: ClientIdentificationDocumentTypeEnum;
	onSelectType?: (type: PaperworkDocType) => void;
};

export const PaperworkTypeList: FC<Props> = ({
	selectedTypeId,
	onSelectType,
}) => {
	const { t } = useResource();

	return (
		<Stack pb={3.2}>
			{PAPERWORK_DOC_CATEGORIES.map((category) => (
				<ProfileSection key={category.id} title={t(category.label)}>
					{category.types.map((type, index) => (
						<Fragment key={type.id}>
							{index > 0 && (
								<Stack ml={7.2} borderTop={1} borderColor="surface.border" />
							)}
							<PaperworkTypeRow
								icon={getDocumentIcon(type.id)}
								tone={category.tone}
								name={t(type.name)}
								selected={type.id === selectedTypeId}
								onClick={onSelectType && (() => onSelectType(type))}
							/>
						</Fragment>
					))}
				</ProfileSection>
			))}
		</Stack>
	);
};
